import styled from 'styled-components'

export const ErrorMessage = styled.small`
	color: var(--color-error);
	font-size: 0.6em;
`
